import { render } from "./DetailText.vue?vue&type=template&id=13e3871f"
import script from "./DetailText.vue?vue&type=script&lang=js"
export * from "./DetailText.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__